import React, { useEffect, useState } from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
import { getNews } from '../lib/api';
import logger from '../lib/logger';

const NewsPage = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getNews()
      .then(setNews)
      .catch((e) => logger.error(e))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-black text-white min-h-screen">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-14">
        <p className="text-[#909090] text-sm uppercase tracking-widest mb-3">News & Updates</p>
        <h1 className="text-4xl md:text-5xl font-bold mb-10">From the lab.</h1>
        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={`skel-${i}`} className="h-80 bg-zinc-950 border border-zinc-900 rounded animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {news.map((n) => (
              <article key={n.id} className="bg-zinc-950 border border-zinc-900 rounded-md overflow-hidden group hover:border-[#909090]/60 transition-colors">
                <div className="aspect-[16/10] overflow-hidden bg-gradient-to-br from-zinc-900 to-black">
                  <img src={n.image} alt={n.title} className="w-full h-full object-contain p-6 group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <p className="text-xs text-zinc-500 flex items-center gap-2 mb-3">
                    <Calendar size={13} /> {new Date(n.date).toLocaleDateString('en-GB', { day:'numeric', month:'long', year:'numeric'})}
                  </p>
                  <h2 className="text-lg font-semibold mb-2 leading-snug group-hover:text-[#909090] transition-colors">{n.title}</h2>
                  <p className="text-zinc-400 text-sm leading-relaxed mb-4">{n.excerpt}</p>
                  <button className="text-[#909090] text-sm font-medium inline-flex items-center gap-1 hover:gap-2 transition-all">
                    Read more <ArrowRight size={14} />
                  </button>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsPage;
